import axios from "../../axios";

const state = {
  stringeeLogsByStaffs: {},
};

const actions = {
  /**
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  async getStringeeLogsByStaffs({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`call/logs/report-by-staffs?${new URLSearchParams(query)}`, )
        .then((response) => {
          resolve(response);
          commit("SET_STRINGEE_LOGS_BY_STAFFS", response.data.data.items);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  async downloadRecording({ commit }, { callId, token }) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      const url = `https://api.stringee.com/v1/call/recording/${callId}`;
      // Use axios directly - it's already imported at the top
      
      axios.get(url, {
          headers: {
            'X-STRINGEE-AUTH': token,
          },
          responseType: 'blob'
        })
        .then(response => {
          // Tạo một URL từ blob và kích hoạt download
          const blob = new Blob([response.data], { type: response.data.type });
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;

          // Đặt tên file cho download
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'recording.mp3'; // Tên mặc định

          if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '');
            }
          }

          link.download = fileName; // Tên file khi download
          document.body.appendChild(link);
          link.click();
          link.remove();

          resolve(); // Giải quyết Promise
        })
        .catch(error => {
          console.error('Error fetching recording:', error);
        });
    });
  }
};

const mutations = {
  // eslint-disable-next-line no-unused-vars
  SET_STRINGEE_LOGS_BY_STAFFS(state, payload) {
    state.stringeeLogsByStaffs = payload;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
